/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { OutPublicUserWithDataWarehouseProductsDTO, OutPublicUserWithDealsDTO, ProductAlertDTO } from "../models";
import {
  OutPublicUserWithDataWarehouseProductsDTOFromJSON,
  OutPublicUserWithDataWarehouseProductsDTOToJSON,
  OutPublicUserWithDealsDTOFromJSON,
  OutPublicUserWithDealsDTOToJSON,
  ProductAlertDTOFromJSON,
  ProductAlertDTOToJSON
} from "../models";

export interface DislikeEanRequest {
  productAlertDTO: ProductAlertDTO;
}

export interface LikeEanRequest {
  productAlertDTO: ProductAlertDTO;
}

/**
 *
 */
export class PublicUsersApi extends runtime.BaseAPI {
  /**
   */
  async dislikeEanRaw(
    requestParameters: DislikeEanRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutPublicUserWithDealsDTO>> {
    if (requestParameters.productAlertDTO === null || requestParameters.productAlertDTO === undefined) {
      throw new runtime.RequiredError(
        "productAlertDTO",
        "Required parameter requestParameters.productAlertDTO was null or undefined when calling dislikeEan."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/publicUser/dislike`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ProductAlertDTOToJSON(requestParameters.productAlertDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutPublicUserWithDealsDTOFromJSON(jsonValue));
  }

  /**
   */
  async dislikeEan(
    requestParameters: DislikeEanRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutPublicUserWithDealsDTO> {
    const response = await this.dislikeEanRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getMeRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutPublicUserWithDataWarehouseProductsDTO>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/publicUser/me`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OutPublicUserWithDataWarehouseProductsDTOFromJSON(jsonValue)
    );
  }

  /**
   */
  async getMe(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutPublicUserWithDataWarehouseProductsDTO> {
    const response = await this.getMeRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async likeEanRaw(
    requestParameters: LikeEanRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutPublicUserWithDealsDTO>> {
    if (requestParameters.productAlertDTO === null || requestParameters.productAlertDTO === undefined) {
      throw new runtime.RequiredError(
        "productAlertDTO",
        "Required parameter requestParameters.productAlertDTO was null or undefined when calling likeEan."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/publicUser/like`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ProductAlertDTOToJSON(requestParameters.productAlertDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutPublicUserWithDealsDTOFromJSON(jsonValue));
  }

  /**
   */
  async likeEan(
    requestParameters: LikeEanRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutPublicUserWithDealsDTO> {
    const response = await this.likeEanRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
